import LoginRoutes from './routes'

export default {
  // name version 必须为字面常量
  name: 'auth-login',
  title: 'module登录',
  type: 'auth',
  version: '0.1.60',
  description: '对接authserver',
  routes: LoginRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
  config: {
    loginScope: 'AuthServer Portal openid profile address email phone role WizResource',
    needValidateCode: true,
    loginTitle: '', // 登录框标题以及浏览器tab页标题
    loginLogo: '', // 登录框logo以及ico
    qywxTenantName: '', // 扫码租户配置
    qywxQrcodeLoginShow: false, // 是否开启企业微信登录
    appid: 'wwd2d00dedd5c84818',
    agentid: '1000041',
    redirect_uri: 'https://saas.wiz.top',
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
